import { render, staticRenderFns } from "./CertificationCardNew.vue?vue&type=template&id=791505a8&scoped=true"
import script from "./CertificationCardNew.vue?vue&type=script&lang=ts"
export * from "./CertificationCardNew.vue?vue&type=script&lang=ts"
import style0 from "./CertificationCardNew.vue?vue&type=style&index=0&id=791505a8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791505a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('791505a8')) {
      api.createRecord('791505a8', component.options)
    } else {
      api.reload('791505a8', component.options)
    }
    module.hot.accept("./CertificationCardNew.vue?vue&type=template&id=791505a8&scoped=true", function () {
      api.rerender('791505a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profile/CertificationCardNew.vue"
export default component.exports